"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enablePreview = void 0;
var md_1 = __importDefault(require("./utils/md"));
var md_line_number_1 = require("./utils/md-line-number");
exports.enablePreview = function () {
    md_line_number_1.mdLineNumber(md_1.default);
};
var markdownToHtml = function (text) {
    if (!(text && text.length))
        return text;
    return md_1.default.render(text);
};
exports.default = markdownToHtml;
